import { mediaQuery } from 'constants/ui';

export const titleWrapperStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
};

export const summaryBlocksWrapperStyles = {
  display: 'grid',
  gridTemplateColumns: '2fr 1px 1fr',
  gap: '24px',

  [mediaQuery.mobile]: {
    gridTemplateColumns: '1fr',
    '& > hr': {
      display: 'none',
    },
  },
};
